import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import ReferralCreate from "./referralCreate";
import { getProjectTypes,createNewReferral } from "../../../service/Referral/action";
import {documentUploadUrlPublic} from "../../../service/fileUpload/action";
import {locationPinCode, locationCity, locationZone, locationArea, stateAndRegion} from "../../../service/locations/action";

const mapStateToProps = (state) => ({
    projectTypes:state.Referral.projectTypes,
    saveReferral:state.Referral.saveReferral,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    pincodeData: state.locationReducer.pincodeData,
    cities: state.locationReducer.cities,
    zones: state.locationReducer.zones,
    areas: state.locationReducer.areas,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            getProjectTypes,
            createNewReferral,
            locationPinCode, 
            locationCity, 
            locationZone, 
            locationArea, 
            stateAndRegion
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ReferralCreate);
